<template>
    <div class="box">
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="注册证名称">
                <el-input v-model="getRequestData.bgiRegistname"></el-input>
            </el-form-item>
            <el-form-item label="注册证号">
                <el-input v-model="getRequestData.bgiRegistno"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="searchData">查询</el-button>
            </el-form-item>
        </el-form>
        <!-- 表格 -->
        <el-table :fit="true" ref="moviesTable" height="300" size="mini" @row-dblclick="handleSelectClick"
            :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
            @selection-change="handleSelectionChange" style="width: 100%" :data="returnData.list" border>
            <!-- 数字 -->
            <el-table-column align="center" prop="bgiRegistno" label="注册证号" min-width="120"
                show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="bgiRegistname" label="注册证名称" min-width="120"
                show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="glRedate" label="发证日期" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ $common.getLocalTime(scope.row.glRedate) }}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="glTervalidity" label="有效期至" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ $common.getLocalTime(scope.row.glTervalidity) }}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="manualCount" label="说明书数量" min-width="120"
                show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="fileCount" label="文件数量" min-width="120"
                show-overflow-tooltip></el-table-column>

        </el-table>
        <div class="page_content_bottom">
            <el-tag class="elTag" size="small">证照信息</el-tag>
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-table height="200" size="mini" style="width: 100%" :data="returnData.detailsList" border>
            <!-- 数字 -->
            <el-table-column align="center" prop="lityId" label="证照类型" min-width="120"
                show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="glTername" label="证照名称" min-width="120"
                show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="glTernumber" label="证照号码" min-width="120"
                show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="glRedate" label="发证日期" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ $common.getLocalTime(scope.row.glTervalidity) }}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="glTervalidity" label="有效期至" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ $common.getLocalTime(scope.row.glTervalidity) }}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="glUrl" label="证照图片" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                    <ul v-if="scope.row.glUrl" class="uploadList">
                        <li v-for="(val, key) in scope.row.glUrl" :key="key" class="image">
                            <cusImage style="width: 30px; height: 30px;margin-top: 5px;"
                                :src="`${imgUrl}/${val.fileUrl}`" :preview-src-list="getUrl(scope.row.glUrl)">
                            </cusImage>
                        </li>
                    </ul>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: "bgiBrandAction",
    data() {
        return {
            imgUrl: window.global_config.BASE_IMG_URL,
            getRequestData: {
                bgiRegistname: '',
                bgiRegistno: '',
                page: 1,
                rows: 30
            },
            returnData: {
                total: 0,
                list: [],
                detailsList: [],
            },
            selectedRow: [],
            selectedIndex: 0,
            clickTimer: null,
            delay: 500 // 延迟时间（毫秒）
        }
    },
    created() {
        this.getDataList()
    },
    mounted() {
        addEventListener('keyup', this.keyUpChild)
    },
    beforeDestroy() {
        removeEventListener('keyup', this.keyUpChild)
    },
    methods: {
        getUrl(list) {
            return list.map(val => `${this.imgUrl}/${val.fileUrl}`)
        },
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },
        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.baseregistnoquery(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.total = responseData.result.total;
                if (this.returnData.list.length > 0) {
                    this.selectedIndex = 0
                    this.$nextTick(() => {
                        setTimeout(() => {
                            let refsElTable = this.$refs.moviesTable;
                            console.log(refsElTable);
                            refsElTable.clearSelection();
                            refsElTable.toggleRowSelection(this.returnData.list[this.selectedIndex]);
                        }, 100)
                        this.getDetailsList(this.returnData.list[this.selectedIndex])
                    });
                }

            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getDetailsList(row, flag) {
            this.returnData.detailsList = []
            let responseData = await this.$http.baseregistnoqueryDetail({ ids: [row.regId] });
            console.log(responseData);
            if (responseData.status == 200) {
                this.returnData.detailsList = [
                    {
                        lityId: "注册证号",
                        glTername: "注册证号",
                        glTernumber: responseData.result.bgiRegistno,
                        glReoffice: "",
                        glRedate: responseData.result.glRedate,
                        glTervalidity: responseData.result.glTervalidity,
                        remark: "",
                        glUrl: responseData.result.fileList.map(val => {
                            return {
                                ...val,
                                url: `${this.imgUrl}/${val.fileUrl}`
                            }
                        })
                    },
                    {
                        lityId: "说明书",
                        glTername: "说明书",
                        glTernumber: responseData.result.bgiRegistno,
                        glReoffice: "",
                        // glRedate: responseData.result.glRedate,
                        // glTervalidity: responseData.result.glTervalidity,
                        glRedate: "",
                        glTervalidity: "",
                        remark: "",
                        glUrl: responseData.result.manualList.map(val => {
                            return {
                                ...val,
                                url: `${this.imgUrl}/${val.fileUrl}`
                            }
                        })
                    },
                ]
                if (flag) {
                    this.$emit("TranData", {
                        row: row,
                        detailsList: this.returnData.detailsList
                    });
                }
            }

        },
        // 双击确认
        handleSelectClick(row, column, event) {
            clearTimeout(this.clickTimer); // 清除单击事件的定时器
            this.getDetailsList(row, true)
        },
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') {
                rowBackground.backgroundColor = row.bgColor
            }
            if (this.isRepetition) {
                this.isRepetitionList.forEach(item => {
                    if (item[this.isProp] == row[this.isProp]) {
                        rowBackground.backgroundColor = "#dedede"
                    }
                })
            }
            return rowBackground
        },
        clickEvent(row, column, event, params) {
            clearTimeout(this.clickTimer);
            this.clickTimer = setTimeout(() => {
                let refsElTable = this.$refs.moviesTable; // 获取表格对象
                this.selectedIndex = row.rowIndex;
                let findRow = {};
                findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
                //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                if (findRow && this.selectedRow.length === 1) {
                    refsElTable.toggleRowSelection(row, false);
                    return;
                }
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(row);
                this.getDetailsList(row)
            }, this.delay);
        },
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        keyUpChild(e) {
            // 表格为空，不执行下方 
            if (this.returnData.list.length == 0) return

            if (e.keyCode == 40) { // 下键
                let refsElTable = this.$refs.moviesTable
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 如果当前没有选中行，则直接选中第一个
                        this.selectedIndex = 0;
                    } else if (this.selectedIndex == this.returnData.list.length - 1) {
                        // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedIndex = 0;
                    } else {
                        // 正常递增
                        this.selectedIndex++;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.returnData.list[this.selectedIndex],
                            false
                        );
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.returnData.list[this.selectedIndex]); // 把现在当前行勾选
                    this.getDetailsList(this.returnData.list[this.selectedIndex])

                });
            } else if (e.keyCode == 38) {
                // 上键
                let refsElTable = this.$refs.moviesTable;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 当前没有选中行，则直接选中第一个
                        this.selectedIndex = 0;
                    } else if (this.selectedIndex == 0) {
                        // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedIndex = this.returnData.list.length - 1;
                    } else {
                        // 正常递减
                        this.selectedIndex--;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.returnData.list[this.selectedIndex],
                            false
                        );
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.returnData.list[this.selectedIndex]); // 把现在当前行勾选
                    this.getDetailsList(this.returnData.list[this.selectedIndex])
                });
            }
        },
    },
}
</script>

<style scoped>
.page_content_bottom {
    position: relative;
}

.elTag {
    position: absolute;
    bottom: 5px;
}

/* 图片上传样式 */
.uploadList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 220px;
    list-style: none;
}

.image {
    position: relative;
    width: 40px;
    height: 40px;
    margin-right: 5px;
    margin-bottom: 5px;
    flex-shrink: 0;
    border: 1px solid #f3f3f3;
}

.image:nth-child(5n) {
    margin-right: 0;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.image:hover .del {
    display: inline-block;
}

.image_label {
    cursor: pointer;
    padding: 7px 10px !important;
    font-size: 12px !important;
    background-color: #409eff;
    color: #ffffff;
    line-height: 14px;
    margin-right: 5px;
    border-radius: 3px;
}

::v-deep .el-image__error {
    font-size: 7px;
}
</style>